'use strict';
/**
 * The nav toggle button
 */

angular.module('youth').directive('navToggle', ['navSvc', function (navSvc) {
  return {
    templateUrl: 'youth/templates/nav-toggle.html',
    restrict: 'E',
    link: function link(scope) {
      scope.toggleNav = function () {
        navSvc.toggle();
      };
    }
  };
}]);